import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { loadTrendingTopics, saveTrendingTopic } from '../../api';
import {
  LOADED_TRENDING_TOPICS,
  LOADING_TRENDING_TOPICS,
  SAVED_TRENDING_TOPIC
} from './types';
import { AppState } from '../../store';
import { TopicViewModel } from '../../model/topic/types';

const loadTrendingTopicsStarted = () => {
  return {
    type: LOADING_TRENDING_TOPICS
  };
};

const loadTrendingTopicsCompleted = (data: TopicViewModel[]) => {
  return {
    type: LOADED_TRENDING_TOPICS,
    payload: data
  };
};

const savedTrendingTopic = (topic: TopicViewModel) => {
  return {
    type: SAVED_TRENDING_TOPIC,
    payload: topic
  };
};

export const loadTrendingTopicsForUser = (
  token: string
): ThunkAction<void, AppState, null, Action<string>> => async dispatch => {
  dispatch(loadTrendingTopicsStarted());

  const response = await loadTrendingTopics(token);
  dispatch(loadTrendingTopicsCompleted(response.data));
};

export const saveTrendingTopicForUser = (
  token: string,
  topic: TopicViewModel
): ThunkAction<void, AppState, null, Action<string>> => async dispatch => {
  const response = await saveTrendingTopic(token, topic.termSetMapId);
  if (response.status === 204) dispatch(savedTrendingTopic(topic));
};
